module.exports = __webpack_public_path__ + "img/money.f89eac32.svg";